import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import {
  getStorageAllocationsForOperatorPageParamsSchema,
  getStorageAllocationsForShipperPageParamsSchema,
} from 'src/pages/storage/allocations/overview/schema';

const commonFilters = {
  offerName: { label: 'Offer Name' },
  allocationBusinessId: { label: 'Deal ID' },
  storageLocationId: { label: 'Storage Location' },
  runtimeStart: { label: 'Product Runtime' },
  runtimeEnd: { label: 'Product Runtime' },
};

export function useStorageAllocationsForOperatorPageParams() {
  return usePageParamsFromSchema(
    getStorageAllocationsForOperatorPageParamsSchema(),
    {
      filters: {
        ...commonFilters,
        shipperOrganisationId: { label: 'Shipper' },
      },
    }
  );
}

export type StorageAllocationsForOperatorPageParams = ReturnType<
  typeof useStorageAllocationsForOperatorPageParams
>;

export function useStorageAllocationsForShipperPageParams() {
  return usePageParamsFromSchema(
    getStorageAllocationsForShipperPageParamsSchema(),
    {
      filters: {
        ...commonFilters,
        ssoOrganisationId: { label: 'SSO' },
      },
    }
  );
}

export type StorageAllocationsForShipperPageParams = ReturnType<
  typeof useStorageAllocationsForShipperPageParams
>;
